import { useEffect, useRef, useState } from "react";

import {ReactComponent as NewChatIcon} from "./icons/chat.svg";
import {ReactComponent as HistoryArrowDownIcon} from "./icons/chevron-down.svg";
import {ReactComponent as  HistoryArrowUpIcon} from "./icons/chevron-up.svg";
import { ParentProps } from "./interface";
import { TooltipTextProps } from "./interface";
import TempApp from "./tooltipbuttons";
import ToolTipButtons from "./tooltipbuttons";

export default function NewHistory({
  handleHistoryID,
  histories,
  historyID,
  chatWindowMinimized
}: ParentProps) {
  let [historyToggle, setHistoryToggle] = useState<boolean>(false);
  // State to keep track of the clicked button index
  const [clickedButtonIndex, setClickedButtonIndex] = useState<number | null>(
    null
  );

  // // Function to get the background color
  // const getBackgroundColor = (index: number) => {
  //   return historyID === index ? "#7F26D3" : "white";
  // };

  // const getTextColor = (index: number) => {
  //   return historyID === index ? "white" : "black";
  // };

  return (
    <header
      className="w-1/4  hidden lg:block"
      style={{ background: "#f5f5f5" }}
    >
      <nav
        className="bg-white flex-col p-2 mt-8 ml-8 mr-2 rounded-t-lg lg:px-4 shadow-md shadow-slate-500"
        aria-label="Global"
      >
          <div>
            <button
              className="w-full -mx-3 flex items-center gap-2 rounded-lg px-3 py-1 text-base font-semibold leading-7 text-gray-900"
              onClick={() => {
                setHistoryToggle(!historyToggle);
              }}
            >
              <p className="font-bold">Recent Chats</p>
              <div className="w-6 h-10">
                {historyToggle ? (
                  <div style={{ color: "#7500C0" }}>
                    <HistoryArrowDownIcon />
                  </div>
                ) : (
                  <div style={{ color: "#7500C0" }}>
                    <HistoryArrowUpIcon />
                  </div>
                )}
              </div>
            </button>
          </div>
          {historyToggle && (
            <div className="space-y-2 py-2 w-full max-h-[50dvh] overflow-y-auto overflow-x-hidden">
              {histories.map((item) => {
                // let [convTitle, setConvTitle] = useState<string>();
                // useEffect(() => {
                //   const { current } = textRef;
                //   if (current) {
                //     setIsTruncated(current.scrollWidth > current.clientWidth);
                //   }
                // }, [convTitle]);
                // setConvTitle(item.conversation_title);
                return (
                  // <div>
                  //   <div ref={textRef}>
                  //     <button
                  //       key={item.conversation_id}
                  //       onClick={() => {
                  //         handleHistoryID(item.conversation_id);
                  //         handleButtonClick(item.conversation_id);
                  //       }}
                  //       className={`-mx-3 mr-3 text-left bg-${getBackgroundColor(
                  //         item.conversation_id
                  //       )} truncate h-[36px] w-[260px] block px-4 py-1 text-base font-semibold leading-7 text-gray-900 hover:bg-[#7F26D3] hover:text-white`}
                  //       style={{
                  //         backgroundColor: getBackgroundColor(
                  //           item.conversation_id
                  //         ),
                  //         color: getTextColor(item.conversation_id),
                  //       }}
                  //     >
                  //       {/* {setTitle(item.conversation_title)} */}
                  //       {/* <TempApp text={item.conversation_title} /> */}
                  //       {item.conversation_title}
                  //     </button>
                  //   </div>
                  //   {isTruncated && (
                  //     <div className="absolute z-[10000] text-black ml-64 top-[1px] bottom-full mb-1 hidden w-max max-w-xs bg-gray-700 text-white text-sm p-2 rounded-md group-hover:block">
                  //       {item.conversation_title}
                  //     </div>
                  //   )}
                  <ToolTipButtons
                    key={item.conversation_id}
                    conversation={item}
                    historyID={historyID}
                    handleHistoryID={handleHistoryID}
                  />
                  // </div>
                );
              })}
            </div>
          )}
        
      </nav>
      <div
        className="rounded-b-lg ml-8 mr-2 p-2 lg:px-4 shadow-md shadow-slate-500"
        style={{ backgroundColor: "#dfdfdf" }}
      >
        <button
          onClick={() => {
            handleHistoryID(-1);
          }}
          className="w-full flex items-center gap-2 rounded-lg  text-base font-semibold leading-7 text-gray-900"
        >
          <div className="w-6 h-8">
            <NewChatIcon />
          </div>
          <p>Start new chat</p>
        </button>
      </div>
      {/* <TempApp text="Welcome, I am your conversation AI Assistant. How can I help you today? You can ask me anything related to the Demand Planning and Your Data. At any time if you wish to end the conversation, please type 'exit'."/> */}
    </header>
  );
}
